import { render, staticRenderFns } from "./userMenu.vue?vue&type=template&id=0ce3b705&scoped=true&"
import script from "./userMenu.vue?vue&type=script&lang=ts&"
export * from "./userMenu.vue?vue&type=script&lang=ts&"
import style0 from "./userMenu.vue?vue&type=style&index=0&id=0ce3b705&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce3b705",
  null
  
)

export default component.exports